<template>
  <v-row>
    <v-col
      cols="12"
      md="9"
    >
      <v-card>
        <v-card-title class="d-flex align-center flex-wrap pb-2">
          <span class="text-h6">Права роли</span>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            single-line
            dense
            outlined
            hide-details
            clearable
            placeholder="Поиск по правам..."
            class="permission-search"
          ></v-text-field>
        </v-card-title>

        <v-card-subtitle class="pb-4">
          Отмечено {{ selectedCount }} из {{ permissions.length }}
        </v-card-subtitle>

        <v-divider></v-divider>

        <v-card-text class="pt-0">
          <div
            v-for="group in groups"
            :key="group.title"
            class="permission-group"
          >
            <div class="d-flex align-center py-3">
              <span class="text-subtitle-2">{{ group.title }}</span>
              <v-chip
                x-small
                class="ms-2"
                :color="group.selected ? 'primary' : ''"
              >
                {{ group.selected }} / {{ group.items.length }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn
                small
                text
                color="primary"
                @click="toggleGroup(group)"
              >
                {{ group.selected === group.items.length ? 'Снять все' : 'Выбрать все' }}
              </v-btn>
            </div>

            <v-row dense>
              <v-col
                v-for="item in group.items"
                :key="item.permissionName"
                cols="12"
                sm="6"
              >
                <v-checkbox
                  v-model="item.isSelected"
                  :label="item.title || item.permissionName"
                  :title="item.permissionName"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-divider class="mt-3"></v-divider>
          </div>

          <p
            v-if="!groups.length"
            class="text--secondary mb-0 py-6 text-center"
          >
            По запросу ничего не нашлось
          </p>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      md="3"
    >
      <v-card class="mb-6">
        <v-card-text>
          <v-btn
            class="mb-3"
            block
            color="success"
            @click="submitData"
          >
            Применить
          </v-btn>
          <v-btn
            class="mb-3"
            color="secondary"
            block
            outlined
            @click="cancel"
          >
            Отмена
          </v-btn>

          <p class="text--secondary text-sm mb-0">
            Права начнут действовать при следующем входе сотрудника: список прав он получает
            вместе с токеном.
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RoleEdit',
  data: () => ({
    search: '',
  }),
  computed: {
    ...mapState('role/form', {
      permissions: 'permissions',
    }),
    selectedCount() {
      return this.permissions.filter(x => x.isSelected).length
    },

    groups() {
      const query = (this.search || '').trim().toLowerCase()
      const groups = []
      const byTitle = {}

      this.permissions.forEach(item => {
        const title = item.group || 'Прочее'
        const matches = !query
          || (item.title || '').toLowerCase().includes(query)
          || item.permissionName.toLowerCase().includes(query)
          || title.toLowerCase().includes(query)

        if (!matches) return

        if (!byTitle[title]) {
          byTitle[title] = { title, items: [], selected: 0 }
          groups.push(byTitle[title])
        }

        byTitle[title].items.push(item)
      })

      groups.forEach(group => {
        group.selected = group.items.filter(x => x.isSelected).length
      })

      return groups
    },
  },
  async created() {
    document.title = 'Права роли'
    const { id } = this.$route.params
    this.fetchPermissions(id)
  },
  methods: {
    ...mapActions('role/form', {
      fetchPermissions: 'fetchById',
      updatePermissions: 'update',
    }),
    toggleGroup(group) {
      const select = group.selected !== group.items.length
      group.items.forEach(item => {
        item.isSelected = select
      })
    },
    async submitData() {
      await this.updatePermissions()
      this.$router.back()
    },
    cancel() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.permission-search {
  max-width: 16rem;
}

.permission-group:last-child ::v-deep .v-divider {
  display: none;
}
</style>
